import { ProposalResponseViewModel } from 'types/proposal';
import { TableFiltersState, TableParams } from 'types/common';

export type ProposalsTableParams = TableParams & Pick<TableFiltersState, 'from' | 'to' | 'activeStatus'>;

export type State = {
    isLoading: boolean;
    list: ProposalResponseViewModel[];
    tableParams: ProposalsTableParams;
    totalCount: number;
};

export const tableColumns = [
    {
        id: '1',
        field: 'isActive',
        label: 'Active',
    },
    {
        id: '2',
        field: 'title',
        label: 'Title',
    },
    {
        id: '3',
        field: 'total',
        label: 'Total',
    },
    {
        id: '4',
        field: 'createdDate',
        label: 'Created',
    },
    {
        id: '5',
        field: 'expirationDate',
        label: 'Expired',
    },
];

export const initialProposalsTableParams: TableParams = {
    sortOrder: 'asc',
    orderBy: tableColumns[0].field,
    page: 0,
    pageSize: 5,
    search: undefined,
};

export const initialState: State = {
    isLoading: true,
    list: [],
    tableParams: { ...initialProposalsTableParams, from: '', to: '', activeStatus: true },
    totalCount: 0,
};
